import React from 'react';
import { Link } from 'react-router-dom';

const LiquidMilk = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/projects" className="hover:text-accent"> Projects</Link> / 
            <span className="text-gray-900"> Liquid Milk Processing Plant</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Liquid Milk Processing Plant</h1>
          <p className="text-xl text-gray-300">Complete Turnkey Solutions from 5,000 to 10,00,000 Liters/Day</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700 mb-6">
            ATHENA offers a qualitative range of liquid Milk Processing Plant. The plant is used to process liquid milk which contains a variety of minerals such as calcium, potassium, sodium, phosphorus and magnesium with carbohydrates, lactose, protein and fat. ATHENA offers milk processing plant of capacity 5,000 to 10,00,000 liter milk every day. The Milk Processing plants offered by us to our clients are on a turnkey basis.
          </p>

          <h2 className="text-3xl font-bold mb-6 section-title">Process Description</h2>
          <p className="text-gray-700 mb-6">
            The fat and SNF content have been adjusted to a certain level for standardized milk production. The standardization is done either by addition of SMP or by skimming of milk from Cream separator. The fat and SNF contents may be varied according to product requirement.
          </p>
          <p className="text-gray-700 mb-6">
            The calculated amount of potable water is heated up to 38 deg C and is received in SS mixing tank equipped with an agitator. Then calculated amount of SMP/butter oil/unsalted butter is slowly added at the point of agitation and the mixer is thoroughly agitated till it dissolves completely. The mixture is pumped through a filter and pasteurized and homogenized to ensure proper emulsification of milk fat.
          </p>
        </div>
      </section>

      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold mb-8 section-title">Different Categories of Milk Polypack Available</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="text-left">Milk Type</th>
                  <th className="text-left">Fat Content</th>
                  <th className="text-left">SNF Content</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Standardized Milk</td>
                  <td>4.5%</td>
                  <td>8.5%</td>
                </tr>
                <tr>
                  <td>Recombined Milk</td>
                  <td>3.0%</td>
                  <td>8.5%</td>
                </tr>
                <tr>
                  <td>Toned Milk</td>
                  <td>3.0%</td>
                  <td>8.5%</td>
                </tr>
                <tr>
                  <td>Double Toned Milk</td>
                  <td>1.5%</td>
                  <td>9.0%</td>
                </tr>
                <tr>
                  <td>Skim Milk</td>
                  <td>&lt;0.5%</td>
                  <td>8.7%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Set Up Your Milk Processing Plant?</h2>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Get a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default LiquidMilk;